import React from "react";

function SearchScreen(props) {
  return <div>{props.searchFor}</div>;
}

export default SearchScreen;
